// extracted by mini-css-extract-plugin
export default {"container":"PaymentButtonAction_container__WrJwf","deleteIcon":"PaymentButtonAction_deleteIcon__Fr6fs","icon":"PaymentButtonAction_icon__JSSqP"};